// eslint-disable
// This file is generated dynamically through `node prepare-locales.js`. Please do content changes in `shopify/assets/locales/*.json`, update the filter rules in `prepare-locales.js` and run `node prepare-locales.js`.

import type { Locale } from './en'

if (!window.seebergerLocales) {
  window.seebergerLocales = {}
}

window.seebergerLocales.cs = {
  general: {
    forms: {
      inputs: {
        labels: {
          email: 'E‑mail',
          firstName: 'Křestní jméno',
          lastName: 'Příjmení',
        },
        placeholders: {
          email: 'např. jan.novak@email.cz',
          firstName: 'např. Jan',
          lastName: 'např. Novák',
        },
        errors: {
          email: 'Prosím vyplňte e‑mail.',
          firstName: 'Prosím vyplňte křestní jméno.',
          lastName: 'Prosím vyplňte příjmení.',
        },
      },
      response: {
        error: {
          text: 'Zkontrolujte prosím své údaje a zkuste to znovu. Následující pole obsahují chyby: ',
        },
        success: {
          text: (data: { firstname: string; subject: string }) =>
            `Děkujeme za vaši zprávu, ${data.firstname}. V co nejbližší době vás kontaktujeme ohledně „${data.subject}“.`,
        },
      },
      privacy_policy: 'Zásady ochrany osobních údajů',
      contact_information: 'Kontaktní informace',
    },
    links: {
      go_to: {
        product: (data: { productTitle: string }) =>
          `Více informací o ${data.productTitle}`,
        link: (data: { linkTitle: string }) => `Více o ${data.linkTitle}`,
      },
    },
  },
  brevo_form: {
    success: {
      title: 'Děkujeme za registraci',
      text: 'Prosím zkontrolujte svou schránku (včetně spamu) pro potvrzení registrace.',
    },
    error: {
      title: 'Došlo k chybě',
      text: 'Prosím deaktivujte AdBlocker a zkontrolujte své internetové připojení.',
    },
  },
  accessibility: {
    close_notification: 'Zavřít upozornění',
  },
  products: {
    product: {
      options: {
        more_single: 'Další',
        more_plural: 'Další',
      },
      option_name: {
        pack: 'Balíček',
        pack_number: {
          '1_html': 'Jednotlivý produkt',
          '3_html': '3 kusy',
          '6_html': '6 kusů',
          '12_html': '12 kusů',
          '24_html': '24 kusů',
          default_html: (data: { count: string }) => `${data.count} kusů`,
        },
        discount_html: (data: { percent: string }) =>
          `Ušetřete ${data.percent}%`,
      },
      colli_label: {
        default_html: (data: { count: string }) => `${data.count} ks`,
      },
      add_to_cart: 'Přidat do košíku',
      add_to_cart_sm: 'Do košíku',
      add_to_cart_title: (data: { productTitle: string }) =>
        `Přidat ${data.productTitle} do košíku`,
      new: 'Nové',
      quantity: {
        input_label: (data: { product: string }) => `Množství ${data.product}`,
        increase: (data: { product: string }) =>
          `Zvýšit množství ${data.product}`,
        decrease: (data: { product: string }) =>
          `Snížit množství ${data.product}`,
        limit_reached_error: (data: {
          totalRequestedQuantity: string
          maxAvailable: string
        }) =>
          `Požadované množství ${data.totalRequestedQuantity} není k dispozici. Maximální dostupné množství je ${data.maxAvailable}.`,
        limit_reached_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          availableMultipackQuantity: string
          maxAvailable: string
        }) =>
          `Požadované množství ${data.multiplicator}x${data.multipackQuantity} není k dispozici. Maximální dostupné multipacky jsou ${data.availableMultipackQuantity}x${data.multipackQuantity} nebo ${data.maxAvailable} jednotlivé produkty.`,
        limit_reached_with_cart_items_error: (data: {
          requestedQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `Požadované množství ${data.requestedQuantity} není k dispozici, protože již máte v košíku ${data.cartItemsCount} položek. Celkové dostupné množství je ${data.maxAvailable}.`,
        limit_reached_with_cart_items_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `Požadované množství ${data.multiplicator}x${data.multipackQuantity} není k dispozici, protože již máte v košíku ${data.cartItemsCount} položek. Celkové dostupné množství jednotlivých produktů je ${data.maxAvailable}.`,
        minimum_quantity_error: (data: { min: string }) =>
          `Musíte objednat alespoň ${data.min} položek.`,
      },
      price: {
        from: 'Od',
      },
      sold_out: 'Vyprodáno',
      diet_disclaimer: 'Podle receptury, možné křížové kontaminace.',
      sugar_disclaimer: 'Obsahuje přirozeně se vyskytující cukr.',
      salt_disclaimer: 'Obsahuje přirozeně se vyskytující sůl.',
      nutrient_data: {
        title: 'Nutriční hodnoty',
        'title-average': 'Průměrné nutriční hodnoty',
        'per-unit': '100g',
        caloricvalue: 'Energetická hodnota (kJ/kcal)',
        fat: 'Tuky',
        fat_of_which_saturates: 'z toho nasycené mastné kyseliny',
        fat_of_which_mono_unsaturates: 'z toho mononenasycené mastné kyseliny',
        carbohydrate: 'Sacharidy',
        carbohydrate_of_which_sugars: 'z toho cukry',
        carbohydrate_of_which_polyols: 'z toho polyoly',
        carbohydrate_of_which_starch: 'z toho škrob',
        fibre: 'Vláknina',
        protein: 'Bílkoviny',
        salt: 'Sůl',
        vitamin_e: 'Vitamin E',
        potassium: 'Draslík',
        chloride: 'Chlorid',
        calcium: 'Vápník',
        phosphorus: 'Fosfor',
        omega_3_fatty_acids: 'Omega 3 mastné kyseliny',
        magnesium: 'Hořčík',
        iron: 'Železo',
        zinc: 'Zinek',
        copper: 'Měď',
        manganese: 'Mangan',
        fluoride: 'Fluorid',
        selenium: 'Selen',
        chromium: 'Chrom',
        molybdenum: 'Molybden',
        iodine: 'Jód',
        fat_of_which_polyunsaturates:
          'z toho vícenásobně nenasycené mastné kyseliny',
        vitamin_a: 'Vitamin A',
        vitamin_d: 'Vitamin D',
        vitamin_k: 'Vitamin K',
        vitamin_c: 'Vitamin C',
        thiamin: 'Thiamin',
        riboflavin: 'Riboflavin',
        niacin: 'Niacin',
        vitamin_b6: 'Vitamin B6',
        folic_acid: 'Kyselina listová',
        vitamin_b12: 'Vitamin B12',
        biotin: 'Biotin',
        pantothenic_acid: 'Kyselina pantothenová',
      },
      'filter-p-m-seeberger-diet': {
        label: 'Dieta',
        'gluten-free': 'bezlepkové',
        'lactose-free': 'bez laktózy',
        vegan: 'veganské',
        vegetarian: 'vegetariánské',
        'no-added-sugar': 'bez přidaného cukru',
        'no-added-salt': 'bez přidané soli',
      },
    },
    facets: {
      filter_by_label: (data: { filter: string }) =>
        `Filtrovat podle ${data.filter}`,
    },
  },
  sections: {
    cart: {
      remove_title: (data: { title: string }) => `${data.title} odstranit`,
      presents: {
        button_label: 'Vybrat dárek',
      },
    },
    'sb-popup-variant-overlay': {
      select_option: 'Vyberte možnost',
      select_option_zustand: 'Celé zrno nebo mleté?',
      select_option_inhalt: 'Kolik chcete?',
      select_option_packung: 'Kolik balíčků?',
      title: '',
    },
  },
  localization: {
    international: 'Mezinárodní',
    country_section: 'Země doručení',
    language_section: 'Jazyk',
    country_section_desc: 'Vyberte zemi, do které máme doručovat.',
    language_section_desc: 'Vyberte preferovaný jazyk.',
    redirect_title: 'Přesměrování',
    redirect_message:
      'Za chvíli budete přesměrováni na vybranou jazykovou verzi %selection%.',
    non_order_options: 'Výběr bez možnosti objednání',
  },
  'customer-favorites': {
    'add-to-favorites': 'Přidat do oblíbených',
    'remove-from-favorites': 'Odebrat z oblíbených',
  },
  subscription: {
    discount_html: (data: { value: string }) => `Ušetřete ${data.value}`,
  },
} satisfies Locale
